<template>
    <div class="modal fade modal2" id="file_share_modal" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
            <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Compartir</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <ul class="nav nav-tabs" id="myTab" role="tablist">
                    <li class="nav-item" role="presentation">
                            <button class="nav-link active" id="share-private-tab" data-bs-toggle="tab" data-bs-target="#share-private" type="button" role="tab" aria-controls="share-private" aria-selected="true">Privado</button>               </li>
                    <li class="nav-item" role="presentation">
                            <button :class="{ 'nav-link': true, 'active': showManualInput }" id="share-public-tab" data-bs-toggle="tab"  data-bs-target="#share-public" type="button" role="tab" aria-controls="share-public"  aria-selected="false" @click="toggleManualInput(true); clearUrlInput()">Público</button>
                    </li>
                </ul>
                <div class="tab-content" id="myTabContent">
                        <div class="tab-pane fade show active" id="share-private" role="tabpanel" aria-labelledby="share-private">
                            <div class="alert alert-info margin-top-20" role="alert"> Sólo se podrá visualizar este documento por tiempo limitado
                        </div>
                       <div class="mb-3">
                                <div class="btn-group w-100" role="group" aria-label="Duración predefinida">
                                    <button type="button" class="btn btn-outline-secondary btn-time" :class="{ 'active': form_share.private.duration === 60 }" @click="setDuration(60)">1 min</button>
                                    <button type="button" class="btn btn-outline-secondary btn-time" :class="{ 'active': form_share.private.duration === 300 }" @click="setDuration(300)">5 min</button>
                                    <button type="button" class="btn btn-outline-secondary btn-time" :class="{ 'active': form_share.private.duration === 1800 }" @click="setDuration(1800)">30 min</button>
                                    <button type="button" class="btn btn-outline-secondary btn-time" :class="{ 'active': form_share.private.duration === 3600 }" @click="setDuration(3600)">1 hora</button>
                                    <button type="button" class="btn btn-outline-secondary btn-time" :class="{ 'active': showManualInput }" @click="toggleManualInput(true); clearUrlInput()">Manual</button>
                                </div>
                                <input v-if="showManualInput" v-model="form_share.private.duration" type="text"  class="form-control mt-2" id="recipient-name" maxlength="8" placeholder="Ingresa Duración manual (segundos)">
                                <label v-if="showManualInput" class="form-label mt-2">Duración en (segundos)</label>
                        </div>
                        <div class="input-group mb-3">
                                <input v-on:focus="$event.target.select()" ref="clonep" v-model="form_share.private.url" type="text" class="form-control" placeholder="Enlace Privado" aria-label="Enlace Privado" :disabled="this.form_share.private.disabled" aria-describedby="button-addon2" readonly>
                                <button v-if="this.form_share.private.disabled" class="btn btn-outline-secondary" type="button" @click="get_private_link()">Generar</button>
                                <button v-else class="btn btn-outline-secondary" type="button" @click="copy('private')">Copiar</button>
                        </div>
                        <div class="input-group mb-3">
                                <input v-model="form_share.private.emails" type="text" class="form-control"  placeholder="Email (Separar por coma)">
                                <button class="btn btn-outline-secondary" type="button" @click="share('private')">Enviar</button>
                        </div>
                            <div class="mb-3"></div>
                        </div>
                        <div class="tab-pane fade show" id="share-public" role="tabpanel"  aria-labelledby="share-public">
                        <div class="alert alert-info margin-top-20" role="alert">
                            Cualquier persona podrá visualizar este documento
                        </div>
                        <div class="input-group mb-3">
                                <input v-on:focus="$event.target.select()" ref="clone" v-model="form_share.public.url" type="text" class="form-control" placeholder="Enlace Público" aria-label="Enlace Público" :disabled="this.form_share.public.disabled" aria-describedby="button-addon2">
                                <button v-if="this.form_share.public.disabled" class="btn btn-outline-secondary" type="button" @click="get_public_link()">Generar</button>
                                <button v-else class="btn btn-outline-secondary" type="button" @click="copy('public')">Copiar</button>
                        </div>
                        <div class="input-group mb-3">
                                <input v-model="form_share.public.emails" placeholder="Email (Separar por coma)" type="text" class="form-control" id="recipient-name">
                                <button @click="share('public')" type="button" class="btn btn-outline-secondary">Enviar</button>
                        </div>
                        <div class="mb-3">
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cerrar</button>
            </div>
            </div>
        </div>
    </div>
</template>
<script>
import { Modal } from 'bootstrap'
  export default {
    name: 'FileShare',
    emits: ['closeModal'],
    props: {
        projectId: { type: Number, default: 0 },
        folderId: { type: Number, default: 0 },
        fileId: { type: Number, default: 0 },
        folderFileId: { type: Number, default: 0 },
    },
    data() {
      return {
        modal: null,
        versions: [],
        form_share: {
            private: {
                emails: "",
                message: "",
                    duration: 300,
                url: "",
                disabled: true,
            },
            public: {
                emails: "",
                message: "",
                duration: 300,
                url: "",
                disabled: true
            }
            },
            showManualInput: false,
      }
    },
    mounted() {
        let app = this
        this.modal = new Modal(document.getElementById('file_share_modal'), {})
        this.modal.show()
        document.getElementById('file_share_modal').addEventListener('hide.bs.modal', function () {
            app.$emit('closeModal')
        })
    },
    methods: {
        setDuration(seconds) {
            this.form_share.private.disabled = true;
            this.form_share.private.url = '';
            if (!this.showManualInput && this.form_share.private.duration === seconds) {
                return;
            }
            this.showManualInput = false;
            this.form_share.private.duration = seconds;
        },

        toggleManualInput(showManual) {
            if (showManual) {
                this.showManualInput = true;
            this.form_share.private.disabled = true;
                this.form_share.private.duration = "";
            } else {
                this.showManualInput = false;
            }
        },

        get_public_link() {
            this.axios.post(`projects/${this.projectId}/folders/${this.folderId}/files/${this.fileId}/get_public_link`).then(result => {
                this.form_share.public.url = result.data.body.url
                this.form_share.public.disabled = false
                console.log(result)
            }).catch(error => {
                console.log(error)
                this.$swal({
                    icon: 'error',
                    title: 'Ops! hubo un problema generando el enlace, favor chequea los datos ingresados o intenta más tarde'
                })
            })
        },
        get_private_link() {
            this.axios.post(`projects/${this.projectId}/folders/${this.folderId}/files/${this.fileId}/get_private_link`, { duration: this.form_share.private.duration }).then(result => {
                this.form_share.private.url = result.data.body.url
                this.form_share.private.disabled = false
                console.log(result)
            }).catch(error => {
                console.log(error)
                this.$swal({
                    icon: 'error',
                    title: 'Ops! hubo un problema generando el enlace, favor chequea los datos ingresados o intenta más tarde'
                })
            })
        },
        share(type) {
            let data_form = type == "public" ? { emails: this.form_share.public.emails, message: this.form_share.public.message, type: "public" } : { emails: this.form_share.private.emails, message: this.form_share.private.message, duration: this.form_share.private.duration, type: "private" }
            this.axios.post(`projects/${this.projectId}/folders/${this.folderId}/files/${this.fileId}/share?type=${type}`, data_form).then(result => {
                type == "public" ? (this.form_share.public.emails = null) : (this.form_share.private.emails = null)
                console.log(result)
                 this.$swal({
                    icon: 'success',
                    title: 'Emails enviados con éxito'
                })
            }).catch(error => {
                this.$swal({
                    icon: 'error',
                    title: 'Ops! hubo un problema enviando el email, favor chequea los datos ingresados o intenta más tarde'
                })
                console.log(error)
            })
        },
        copy(type) {
            type == "public" ? this.$refs.clone.focus() : this.$refs.clonep.focus()
            document.execCommand('copy');
        },

        clearUrlInput() {
            this.form_share.private.url = "";
            this.form_share.public.url = "";
        }
    },
    computed: {

    }
  }
</script>

<style>
#modal2 {
    z-index: 2000; 
}

.margin-top-20 {
    margin-top: 20px;
}

.btn-time.active {
    color: rgba(0, 112, 140, 0.42);
    color: white; 
}
</style>